module.exports = __webpack_public_path__ + "img/head-sculpture.dbc62146.png";